import {icons} from 'lib/fontawesome/icons'
import TrieSearch from 'trie-search'

/**
 * Index on the icon name only (e.g. 'twitter'), not the full
 * class string (e.g. 'fab fa-twitter'). Indexing the full string
 * would make every icon match a search for a single letter like
 * 'f', since every class is prefixed with a style token (fas, far,
 * fab, ...) that itself starts with 'f'.
 */
const entries = icons.map((icon) => ({
  name: icon.replace(/^fa[srltdb] fa-/, ''),
  full: icon,
}))

const trie = new TrieSearch('name', {
  splitOnRegEx: /[-]/g,
  min: 1,
})

trie.addAll(entries)

export const findIcon = (value: string) => {
  return trie.search(value).map((res: {full: string}) => res.full)
}
